<template>
  <div class="solicitud-envios-container">
    <v-card
      :flat="!smAndUp"
      :loading="loaderStore.active"
      :disabled="loaderStore.active"
      class="form-container mx-auto"
    >
      <template #loader>
        <v-progress-linear
          v-if="loaderStore.active"
          color="black"
          :height="5"
          indeterminate
        />
      </template>
      <v-toolbar 
        class="toolbar-container" 
        color="primary"
      >
        <v-toolbar-title :class="!smAndUp ? 'text-center' : ''">
          <v-icon>mdi-package-variant</v-icon>
          Solicitud de Mensajeria
          <!-- <v-container fluid class="w-100">
            <v-row>
              <v-col cols="12" sm="6" class="pa-0 d-flex align-center">
                <v-icon class="">mdi-package-variant</v-icon>
                Solicitud de Mensajeria
              </v-col>   
              <v-col cols="12" sm="6" class="d-flex justify-end">         
                <SessionTimer />
              </v-col>
            </v-row>
          </v-container> -->
        </v-toolbar-title>
        <template 
          v-if="smAndUp" 
          #append 
        >
          <SessionTimer />
        </template>
      </v-toolbar>
      <v-card-title
        v-if="!smAndUp"
        class="text-body-1 pt-0 pl-5 pb-3 bg-primary d-flex justify-center"
      >
        <SessionTimer />
      </v-card-title>
      <v-card-text class="form-text pa-0">
        <v-form
          id="steps_parent_container"
          ref="form"
          class="scrollable-form"
          validate-on="blur"
          @submit.prevent="handleNext"
        >
          <v-stepper
            v-model="store.currentStep"
            :mobile="smAndDown"
            :alt-labels="!smAndDown"
            flat
          >
            <v-stepper-header class="elevation-0">
              <template
                v-for="(step, index) in store.stepsHeaders"
                :key="index"
              >
                <v-divider v-if="index" />
                <v-stepper-item
                  :title="step"
                  :step="`Step {{ index + 1 }}`"
                  :value="index + 1"
                  :complete="
                    store.currentStep > index + 1 ||
                      store.currentStep == store.stepsHeaders.length
                  "
                />
              </template>
            </v-stepper-header>
            <v-stepper-window>
              <v-stepper-window-item
                v-for="(item, index) in store.stepsHeaders"
                :key="index"
                :value="index + 1"
              >
                <EmailValidationStep v-if="store.currentStep === 1" />
                <SenderSelectionStep v-if="store.currentStep === 2" />
                <SenderAddressStep v-if="store.currentStep === 3" />
                <RecipientSelectionStep v-if="store.currentStep === 4" />
                <DeliveryAddressStep v-if="store.currentStep === 5" />
                <DeliveryInfoStep v-if="store.currentStep === 6" />
                <v-card 
                  v-if="store.currentStep === 7"
                  flat
                >
                  <v-scale-transition 
                    group 
                    hide-on-leave
                  >
                    <EmptyState v-if="emptyStateStore.active" />
                  </v-scale-transition>
                </v-card>

                <v-scale-transition origin="top left">
                  <small
                    v-if="formMessage.active"
                    class="font-weight-bold text-subtitle-2 text-red"
                  >
                    <v-icon>{{ formMessage.icon }}</v-icon>
                    {{ formMessage.content }}
                  </small>
                </v-scale-transition>
              </v-stepper-window-item>
            </v-stepper-window>
            <!-- <v-stepper-actions>
              <template v-slot:prev>
                <v-btn @click="store.prevStep()" v-if="!store.isFirstStep && !store.requestFinished"
                  variant="text">Regresar</v-btn>
              </template>
              <template v-slot:next>
                <v-btn :disabled="false" @click="handleNext" v-if="!store.requestFinished" variant="text">
                  {{ nextButtonLabel }}
                </v-btn>
              </template>
            </v-stepper-actions> -->
          </v-stepper>
        </v-form>
      </v-card-text>
      <v-card-actions class="fixed">
        <!-- <v-footer class="bg-red"> -->
        <v-btn
          v-if="!store.isFirstStep && !store.requestFinished"
          variant="text"
          @click="store.prevStep()"
        >
          Regresar
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="!store.requestFinished"
          variant="text"
          :disabled="false"
          @click="handleNext"
        >
          {{ nextButtonLabel }}
        </v-btn>
        <!-- </v-footer> -->
      </v-card-actions>
    </v-card>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useDisplay } from "vuetify";
import { useSolicitudMensajeriaStore } from "@/stores/solicitudMensajeria";
import { useLoaderStore } from "@/stores/loader";
import { useEmptyStateStore } from "@/stores/emptyState";
import SessionTimer from "../components/SessionTimer.vue";
import EmptyState from "../components/EmptyState.vue";
import Helpers from "../components/helper.js";

// Components
import EmailValidationStep from "../components/solicitud-mensajeria/EmailValidationStep.vue";
import SenderSelectionStep from "../components/solicitud-mensajeria/SenderSelectionStep.vue";
import SenderAddressStep from "../components/solicitud-mensajeria/SenderAddressStep.vue";
import RecipientSelectionStep from "../components/solicitud-mensajeria/RecipientSelectionStep.vue";
import DeliveryAddressStep from "../components/solicitud-mensajeria/DeliveryAddressStep.vue";
import DeliveryInfoStep from "../components/solicitud-mensajeria/DeliveryInfoStep.vue";

// Breakpoints
const { smAndDown, smAndUp } = useDisplay();

const store = useSolicitudMensajeriaStore();
const loaderStore = useLoaderStore();
const emptyStateStore = useEmptyStateStore();

// Form refs and state
const form = ref(null);
const formMessage = ref({});

// Computed properties
const nextButtonLabel = computed(() => {
  return store.isLastStep ? "Enviar" : "Continuar";
});

// Methods
const handleNext = async () => {
  try {
    let validateForm = await form.value.validate();
    // if (!validateForm.valid) return
    if (!validateForm.valid) {
      // Scroll to the first invalid input field
      let firstError = validateForm?.errors?.at(0);
      if (firstError?.id) {
        let firstErrorField = document.getElementById(firstError.id);
        firstErrorField.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
      return;
    }

    loaderStore.updateLoader(true);

    if (store.currentStep === 1) {
      await store.handleEmailValidation();
    } else if (store.currentStep === 2) {
      store.handleSenderAddress();
    } else if (store.currentStep === 4) {
      store.handleRecipientSelection();
    } else if (store.currentStep === 5) {
      store.fetchTiposDeMensajeria();
    } else if (store.currentStep === 6) {
      await store.handleFormSubmission();
    }

    store.nextStep();
  } catch (error) {
    Helpers.triggerSnackbar(
      error.message || "Error al procesar la solicitud",
      "#b54c4d",
      "#f9edef",
      "mdi-alert-circle-outline",
      2500
    );
    // console.error(error)
  } finally {
    loaderStore.updateLoader(false);
  }
};
</script>

<style scoped>
.form-container {
  width: 50%;
  min-width: 1500px;
  height: 90dvh;
  margin-top: 5dvh;
  display: flex !important;
  flex-direction: column;

  @media only screen and (max-width: 1500px) {
    margin: 0px;
    min-width: 100vw;
    height: 100dvh;
  }
}

.form-text {
  flex-grow: 1;
  overflow: auto;
}

.scrollable-form {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
  contain: content;
}

.v-stepper-window-item {
  transition: all 0.3s ease-in-out;
}

.v-text-field,
.v-autocomplete,
.v-select,
.v-textarea,
.v-number-input,
.v-date-input {
  contain: content;
}
</style>
